module.exports = __webpack_public_path__ + "static/partners-b7bdd137c5b66b4f433b7494ccbe7f27.svg";